<template>
  <div id="app">
    <div class="es-page website">
      <div class="system-website-preview" style="">
        <div class="website-header">
          <div class="content">
            <ul class="website-nav">
              <li><span>青见</span></li>
              <li><span>青见通</span></li>
              <li><span>青见出行</span></li>
              <li><span>青见充电宝</span></li>
            </ul>
          </div>
        </div>
        <div>
          <div class="website-banner">
            <swiper ref="mySwiper" :options="swiperOptions">
              <swiper-slide><img src="./assets/images/banner.png" alt=""></swiper-slide>
              <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
          </div>
        </div>
        <div>
          <div class="website-article menu1">
            <div class="content">
              <div id="section1" class="section left">
                <div class="img"><img src="./assets/images/image2.png" alt=""></div>
                <div class="info"><p class="title">青见打车</p>
                  <p class="text">青见打车是一款专注于为用户提供便捷、安全、高效出行服务的智能打车应用。我们秉承“绿色出行，见证美好”的理念，以用户为核心，致力于打造一站式出行解决方案。</p></div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="website-article menu2">
            <div class="content">
              <div id="section2" class="section right">
                <div class="info"><p class="title">青见通</p>
                  <p class="text">“青见通”是智慧文旅生态系统以小程序、APP程序为数字载体，构建一流互联网运营平台，充分利用其庞大营销矩阵系统，整合全州乃至全省景区门票、酒店、民宿、餐饮、交通、购物、出行等行业资源，打造文化旅游产业聚集平台，统一消费交易端口,实现精准数据统计和信息推送，培育相互支撑的生态环境。</p></div>
                <div class="img"><img src="./assets/images/image3.png" alt=""></div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="website-article sales_support">
            <div class="content"><h2 class="article-title">丰富的营销支持</h2>
              <ul class="sale-list">
                <li class="sale">
                  <div class="img"><img src="./assets/images/fenxiao.png" alt=""></div>
                  <div class="text"><p class="title">分销</p>
                    <p class="info">青见商城全网裂变式分销，智能分佣让更多人帮您销货，迅速扩张提升商城影响力，多渠道数据互通，搭建完善的营销体系。</p></div>
                </li>
                <li class="sale">
                  <div class="img"><img src="./assets/images/pintuan.png" alt=""></div>
                  <div class="text"><p class="title">拼团</p>
                    <p class="info">青见商城基于社交关系传播拼团活动，会员主动向朋友推广宣传，有利于增加信任感提升订单转化率，减少库存</p></div>
                </li>
                <li class="sale">
                  <div class="img"><img src="./assets/images/miaosha.png" alt=""></div>
                  <div class="text"><p class="title">秒杀</p>
                    <p class="info">青见商城通过特价秒杀商品的超低价格，唤醒商城沉睡会员，下单购物提升成单率，让上城整体重新获新生迅猛增长。</p></div>
                </li>
                <li class="sale">
                  <div class="img"><img src="./assets/images/manjian.png" alt=""></div>
                  <div class="text"><p class="title">满额立减</p>
                    <p class="info">多种营销玩法，会员消费满一定金额立减现金，有利于刺激商城会员下单消费，提升商城订单成单率。</p></div>
                </li>
                <li class="sale">
                  <div class="img"><img src="./assets/images/jifen.png" alt=""></div>
                  <div class="text"><p class="title">积分抵扣</p>
                    <p class="info">积分抵扣有利于增加会员粘性，会员通过商城下单可获得积分，积分抵扣享受优惠，有利于促进商城买货，增加订单数量。</p></div>
                </li>
                <li class="sale">
                  <div class="img"><img src="./assets/images/zhekou.png" alt=""></div>
                  <div class="text"><p class="title">折扣</p>
                    <p class="info">商城商品的折扣价有利于辅助商城销货，吸引会员到商城下单，促进商城业绩增加</p></div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div>
          <div class="website-article decorate">
            <div class="content"><h2 class="article-title">强大的DIY店铺装修能力</h2>
              <h3 class="article-subtitle">青见商城个性化定制企业专属电商品牌</h3>
              <div class="decorate">
                <div>
                  <video muted="muted" src="./assets/video/gray.mp4" autoplay="autoplay" loop="loop"></video>
                  <p>后台装修模块演示</p></div>
                <div>
                  <video muted="muted" src="./assets/video/color.mp4" autoplay="autoplay" loop="loop"></video>
                  <p>手机端装修演示</p></div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="website-footer copyright">
            <div class="content "><a href="https://beian.miit.gov.cn/" style="color: #ffffff;">版权所有 Copyright © 2017 All Rights Reserved 黔ICP备16010829号-5</a></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {Swiper, SwiperSlide, directive} from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'

export default {
  name: 'App',
  components: {
    Swiper,
    SwiperSlide
  },
  directives: {
    swiper: directive
  },
  data() {
    return {
      swiperOptions: {
        pagination: {
          el: '.swiper-pagination'
        },
        // Some Swiper option/callback...
      }
    }
  },
}
</script>

<style>

#app, body, html {
  height: 100%
}

* {
  -webkit-box-sizing: border-box;
  box-sizing: border-box
}

:focus {
  outline: none
}

li, ul {
  list-style: none
}

.es-primary-text {
  color: var(--primary, #fb6638)
}

.es-info-text {
  color: var(--info, #4476ff)
}

.es-success-text {
  color: var(--success, #48c978)
}

.es-warning-text {
  color: var(--warning, #fbc712)
}

.es-error-text {
  color: var(--error, #f1495c)
}

.pull-left {
  float: left
}

.pull-right {
  float: right
}

.width-125 {
  width: 125px !important
}

.width-270 {
  width: 270px !important
}

.width-415 {
  width: 415px !important
}

.width-560 {
  width: 560px !important
}

.flex {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex
}

.flex1 {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1
}

.none {
  display: none
}

.pointer {
  cursor: pointer
}

.alignC {
  text-align: center
}

.line-hide {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis
}

.two-line-hide {
  -webkit-line-clamp: 2
}

.three-line-hide, .two-line-hide {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical
}

.three-line-hide {
  -webkit-line-clamp: 3
}


.es-page {
  height: 100%
}

.es-page, .es-page .es-header {
  width: 100%
}

.es-page .es-body {
  width: 100%;
  overflow: hidden;
  min-height: 780px
}

.es-page .es-body .es-content {
  width: 1200px;
  margin: auto;
  min-height: 450px
}

.es-page .es-footer {
  position: relative;
  width: 100%
}

.es-page .es-footer .footer-body {
  margin: auto;
  text-align: center;
  padding: 20px 0
}

.header {
  border-top: none;
  border-bottom: 1px solid #f2f2f2;
  height: 65px
}

.header .menu {
  margin: auto;
  width: 1200px;
  color: #fff;
  background: transparent !important;
  height: 65px;
  line-height: 65px
}

.header .menu .ivu-menu-item {
  padding: 0 20px;
  color: #6e6d70
}

.header .menu .ivu-menu-item:hover {
  color: #fff;
  border: none
}

.header .menu .ivu-menu-item.ivu-menu-item-active, .header .menu .ivu-menu-item.ivu-menu-item-selected {
  color: #6e6d70;
  border: none !important;
  background: #25262a
}

.header .menu .menu-right {
  float: right;
  margin-right: -15px;
  display: inline-block
}

.header .menu .menu-right a {
  padding-top: 5px;
  text-align: right !important;
  display: block
}

.header .menu .menu-right.ivu-dropdown > .ivu-dropdown-rel > a {
  color: #6e6d70 !important;
  font-size: 12px;
  margin-right: 20px
}

.header .notice {
  width: 30px;
  float: right;
  text-align: center;
  margin-right: 20px
}

.header .notice a {
  color: #fff
}

.header .notice .badge {
  font-size: 12px;
  -webkit-box-shadow: none;
  box-shadow: none
}

.header .logo {
  float: left;
  text-align: center
}

.header .logo img {
  max-height: 84px;
  max-width: 140px;
  vertical-align: middle
}

.header .logo img:after {
  width: 0;
  height: 65px;
  display: block;
  vertical-align: middle
}

.header .ivu-menu-light.ivu-menu-horizontal .ivu-menu-item:hover {
  color: #fff
}

.header .ivu-menu-horizontal.ivu-menu-light:after {
  display: none
}

.vertical-center-modal {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center
}

.vertical-center-modal .ivu-modal {
  top: 0
}

.help-block {
  display: block
}

.ivu-checkbox .ivu-checkbox-input {
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  outline: none !important
}

.ivu-checkbox-checked .ivu-checkbox-inner {
  border-color: var(--primary, #fb6638);
  background-color: var(--primary, #fb6638)
}

.captcha-input .ivu-input {
  height: 38px;
  line-height: 38px;
  font-size: 18px;
  width: 80px
}

.captcha-modal .ivu-form-item {
  margin-bottom: 0 !important
}

.captcha-modal .captcha-form-item {
  border: 1px solid #eee;
  border-radius: 4px;
  height: 38px
}

.captcha-modal .captcha-form-item .captcha-img {
  border-radius: 4px;
  width: 136px;
  height: 36px;
  float: left
}

.captcha-modal .captcha-form-item .captcha-reload {
  float: left;
  cursor: pointer;
  display: inline-block;
  width: 36px;
  height: 36px;
  border-left: 1px solid #eee;
  text-align: center;
  line-height: 38px
}

.captcha-modal .captcha-form-item .captcha-reload .ivu-icon {
  color: #ccc
}


.website {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column
}

.website .es-body {
  min-height: auto;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  background: url(/static/dist/account/image/bg.png) no-repeat 50%;
  background-size: cover;
  text-align: center;
  position: relative
}

.website .es-body .index {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  -webkit-transform: translate(-50%, -80%);
  transform: translate(-50%, -80%)
}

.website .es-body .index .title {
  color: #fff;
  font-size: 38px;
  line-height: 98px
}

.website .es-body .index .subtitle {
  color: #fff;
  font-size: 18px;
  line-height: 1;
  margin-bottom: 40px
}

.website .es-body .index .ivu-btn.ivu-btn-primary {
  width: 120px;
  height: 40px;
  line-height: 28px
}

.website .es-body .index .ivu-btn.ivu-btn-primary.ivu-btn-ghost {
  background: transparent
}

.website .es-body .index .ivu-btn.ivu-btn-primary.ivu-btn-ghost:hover {
  background: var(--primary, #fb6638);
  color: #fff
}

.system-website-preview {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding-top: 80px;
  -webkit-transition: all .5s;
  transition: all .5s
}

.system-website-preview .content {
  width: 1200px;
  margin: 0 auto;
  position: relative
}

.system-website-preview .content:after {
  width: 0;
  height: 0;
  content: "";
  visibility: hidden;
  overflow: hidden;
  clear: both;
  display: table
}

.system-website-preview .website-header {
  background: #fff;
  height: 80px;
  padding: 15px 0;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 10;
  -webkit-box-shadow: 0 0 20px rgba(0, 0, 0, .1);
  box-shadow: 0 0 20px rgba(0, 0, 0, .1)
}

.system-website-preview .website-header .logo {
  float: left;
  width: 180px;
  height: 50px
}

.system-website-preview .website-header .logo:after {
  height: 50px;
  display: inline-block;
  content: "";
  width: 0;
  vertical-align: middle
}

.system-website-preview .website-header .logo img {
  max-height: 84px;
  max-width: 140px;
  vertical-align: middle
}

.system-website-preview .website-header .website-nav {
  float: left;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  width: auto
}

.system-website-preview .website-header .website-nav > li {
  margin-right: 28px
}

.system-website-preview .website-header .website-nav > li > span {
  display: block;
  line-height: 50px;
  font-size: 14px;
  color: #3b426b;
  cursor: pointer
}

.system-website-preview .website-header .website-nav > li > span:hover {
  color: #4b7af7
}

.system-website-preview .website-header .btn-box {
  float: right;
  padding: 9px 0
}

.system-website-preview .website-header .btn-box .btn {
  display: inline-block;
  height: 32px;
  margin-right: 12px;
  line-height: 32px;
  padding: 0 24px;
  font-size: 14px;
  color: #fff;
  background-color: #4b7af7;
  border: 1px solid #4b7af7;
  border-radius: 4px;
  cursor: pointer
}

.system-website-preview .website-header .btn-box .btn:hover {
  background-color: #3d6be6;
  border-color: #3d6be6
}

.system-website-preview .website-header .btn-box .btn:last-of-type {
  margin-right: 0
}

.system-website-preview .website-header .btn-box .btn.ghost {
  background-color: #fff;
  color: #4b7af7
}

.system-website-preview .website-header .btn-box .btn.ghost:hover {
  background-color: #4b7af7;
  border-color: #4b7af7;
  color: #fff
}

.system-website-preview .website-banner .swiper-slide {
  overflow: hidden;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  height: 500px
}

.system-website-preview .website-banner .swiper-slide:after {
  display: inline-block;
  height: 500px;
  vertical-align: middle;
  width: 0;
  content: ""
}

.system-website-preview .website-banner .swiper-slide img {
  vertical-align: middle;
  max-height: 500px
}

.system-website-preview .website-banner .swiper-pagination {
  height: 6px;
  bottom: 20px
}

.system-website-preview .website-banner .swiper-pagination .swiper-pagination-bullet {
  width: 8px;
  height: 6px;
  background-color: #dadada;
  border-radius: 3px;
  opacity: 1;
  margin: 0 3px
}

.system-website-preview .website-banner .swiper-pagination .swiper-pagination-bullet-active {
  width: 24px;
  background-color: #fff
}

.system-website-preview .website-article.menu1 {
  padding: 80px 0 40px
}

.system-website-preview .website-article.menu2 {
  padding: 40px 0 80px
}

.system-website-preview .website-article.decorate {
  background-color: #fff;
  padding: 80px 0
}

.system-website-preview .website-article.cases, .system-website-preview .website-article.sales_support {
  background-color: #f5f8ff;
  padding: 60px 0 80px
}

.system-website-preview .website-article.contact {
  background-color: #0c0e10;
  padding-top: 60px;
  padding-bottom: 0
}

.system-website-preview .website-article.contact .article-title {
  color: #9d9d9d;
  font-size: 26px;
  line-height: 26px
}

.system-website-preview .website-article .section {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin-bottom: 60px
}

.system-website-preview .website-article .section:last-of-type {
  margin-bottom: 0
}

.system-website-preview .website-article .section > div {
  -webkit-box-flex: 1;
  -ms-flex: 1 1 50%;
  flex: 1 1 50%
}

.system-website-preview .website-article .section .img:nth-child(n) {
  padding-right: 80px
}

.system-website-preview .website-article .section .img:nth-child(2n) {
  padding-left: 80px
}

.system-website-preview .website-article .section .img img {
  max-width: 490px;
  max-height: 420px
}

.system-website-preview .website-article .section .info .title {
  font-size: 30px;
  font-weight: 600;
  line-height: 30px;
  color: #3b426b;
  margin-bottom: 36px
}

.system-website-preview .website-article .section .info .text {
  font-size: 18px;
  line-height: 40px;
  color: #5d6494;
  white-space: pre-wrap
}

.system-website-preview .website-article .article-title {
  font-size: 34px;
  font-weight: 600;
  color: #3b426b;
  text-align: center;
  line-height: 34px
}

.system-website-preview .website-article .article-subtitle {
  font-size: 24px;
  color: #5d6496;
  text-align: center;
  line-height: 24px;
  margin-top: 24px
}

.system-website-preview .website-article .sale-list {
  margin-top: 72px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  margin-bottom: -54px
}

.system-website-preview .website-article .sale-list .sale {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 570px;
  flex: 0 0 570px;
  height: 190px;
  padding: 42px 48px 0 40px;
  background-color: #fff;
  margin-bottom: 54px;
  -webkit-box-shadow: 0 0 20px rgba(76, 139, 235, .1);
  box-shadow: 0 0 20px rgba(76, 139, 235, .1)
}

.system-website-preview .website-article .sale-list .sale .img {
  float: left;
  margin-right: 28px
}

.system-website-preview .website-article .sale-list .sale .img:after {
  height: 120px;
  display: inline-block;
  content: "";
  width: 0;
  vertical-align: middle
}

.system-website-preview .website-article .sale-list .sale .img img {
  max-width: 120px;
  max-height: 120px;
  text-align: center;
  vertical-align: middle
}

.system-website-preview .website-article .sale-list .sale .text {
  float: left;
  width: 334px
}

.system-website-preview .website-article .sale-list .sale .text .title {
  font-size: 22px;
  color: #3b426b;
  line-height: 22px;
  margin-bottom: 6px
}

.system-website-preview .website-article .sale-list .sale .text .info {
  line-height: 26px;
  font-size: 14px;
  color: #7d88a2;
  white-space: pre-wrap
}

.system-website-preview .website-article .decorate {
  margin-top: 60px;
  text-align: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center
}

.system-website-preview .website-article .decorate video {
  width: 326px;
  margin: 0 40px;
  height: 580px;
  border-radius: 6px;
  -webkit-box-shadow: 2px 0 20px #eee;
  box-shadow: 2px 0 20px #eee
}

.system-website-preview .website-article .decorate p {
  padding-top: 20px;
  color: #7d88a2;
  font-size: 14px
}

.system-website-preview .website-article .caseList {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin-bottom: -46px;
  margin-top: 60px
}

.system-website-preview .website-article .caseList .case {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 372px;
  flex: 0 0 372px;
  margin-bottom: 46px;
  margin-right: 42px;
  height: 300px;
  position: relative
}

.system-website-preview .website-article .caseList .case:nth-of-type(3n) {
  margin-right: 0
}

.system-website-preview .website-article .caseList .case:hover .code-img {
  opacity: 1
}

.system-website-preview .website-article .caseList .case .case-img {
  width: 100%;
  height: 300px
}

.system-website-preview .website-article .caseList .case .code-img {
  position: absolute;
  opacity: 0;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: #fff;
  -webkit-transition: all .5s;
  transition: all .5s;
  text-align: center
}

.system-website-preview .website-article .caseList .case .code-img:after {
  height: 300px;
  width: 0;
  content: "";
  vertical-align: middle;
  display: inline-block
}

.system-website-preview .website-article .caseList .case .code-img img {
  width: 190px;
  height: 190px;
  vertical-align: middle
}

.system-website-preview .website-article .contact-type {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-pack: distribute;
  justify-content: space-around;
  margin-top: 90px;
  height: 244px;
  overflow: hidden
}

.system-website-preview .website-article .contact-type li {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 230px;
  flex: 0 0 230px
}

.system-website-preview .website-article .contact-type .icon-box {
  text-align: center;
  margin-bottom: 28px;
  height: 58px
}

.system-website-preview .website-article .contact-type .icon-box:after {
  display: inline-block;
  content: "";
  vertical-align: middle;
  height: 58px;
  width: 0
}

.system-website-preview .website-article .contact-type .icon-box img {
  vertical-align: middle
}

.system-website-preview .website-article .contact-type .label {
  font-size: 18px;
  color: #4b74f8;
  text-align: center;
  line-height: 18px;
  margin-bottom: 16px
}

.system-website-preview .website-article .contact-type .value {
  font-size: 14px;
  color: #656565;
  line-height: 22px;
  text-align: center
}

.system-website-preview .website-footer {
  height: 80px;
  border-top: 1px solid #252525;
  background-color: #0c0e10
}

.system-website-preview .website-footer p {
  line-height: 80px;
  font-size: 12px;
  color: #5f5f5f;
  text-align: center
}

.system-website-preview .website-footer p a {
  color: #5f5f5f
}


</style>
